// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartFrontSideActions.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { action } from 'mobx';
import { withHandlers, compose, withProps } from 'recompose';
import { get, getOr, curry } from 'lodash/fp';
import { isLinear, openOtherItemsAction } from 'share/utils/Izenda.ReportPartUtils';

export default compose(
  withProps({
    updateDrillComponent: updateDrillComponent,
    setDefaultIntervalForDatetime: setDefaultIntervalForDatetime
  }),
  withHandlers({
    onDrilldown: curry(onDrilldown),
    setPageSize: curry(setPageSize),
    drillOnOthersPeace: curry(drillOnOthersPeace),
    getSortValueForLinearChart
  })
);

/**
 * Drill on Others part
 * @param {Object} props
 * @param {Array<Object>} dataSource
 * @param {Number} currentPositionInLabels
 */
function drillOnOthersPeace(props: any, dataSource: Array<any>, currentPositionInLabels: Number) {
  const {
    reportPart: { reportPartContent }
  } = props;
  const canDrillDown = reportPartContent.canDrillDown(currentPositionInLabels);
  return openOtherItemsAction(props, dataSource, canDrillDown);
}

/**
 * Update drill handler
 */
function updateDrillComponent(): void {
  const reportPart = getOr({}, 'reportPart', this.props);
  reportPart.onDrilldown = this.onDrilldown;
}

/**
 * Set default value for interval date time.
 */
function setDefaultIntervalForDatetime(): void {
  const content = get('reportPart.reportPartContent', this.props);
  content.setDefaultIntervalForDatetime();
}

/**
 * Drill handler
 * @param {Object} props
 * @param {Object} drilldownInfo
 * @param {Object} separator
 */
function onDrilldown(props: any, drilldownInfo: any, separator: any): void {
  const {
    reportPart,
    printingMode,
    reportPart: { reportPartContent },
    store,
    previewRecords
  } = props;
  const canDrilldown = reportPartContent.updateDrilldownInfo(drilldownInfo, separator);

  if (canDrilldown) {
    !!props.publishDrillInfo &&
      props.publishDrillInfo(reportPart.id, reportPart.reportPartContent.getCrossFilteringInfo());
    const loadingProcess = props
      .needUpdatePreview(
        reportPart,
        reportPartContent.getDrilldownInfo(),
        null,
        null,
        printingMode,
        previewRecords,
        null,
        false
      )
      .then(() => {
        reportPartContent.isCrossFiltering && store && store.loadReportPartDataByCrossFiltering(reportPart.id);
      });
    props.showLoading && props.showLoading(loadingProcess);
  }
}

/**
 * Update page size
 * @param {Object} props
 * @param {Object} pageSize
 */
function setPageSize(props: any, pageSize: any): void {
  return props.reportPart.reportPartContent.setPageSize(pageSize);
}

/**
 * Get sort value for chart, when xAxis type is linear
 */
function getSortValueForLinearChart(props: any) {
  return action(() => {
    const { reportPart } = props;
    if (!reportPart) return null;

    const reportPartContent = reportPart.reportPartContent;
    const currentDrilldownField = get('currentDrilldownField', reportPartContent);

    // Get sort value for the current drilldown field
    const sortValue = get('properties.dataFormattings.sort', currentDrilldownField);

    return isLinear(currentDrilldownField, reportPartContent.defaultOptionsByType) ? sortValue : null;
  });
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.ChartFrontSideActions.js